import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { WjNavModule } from '@grapecity/wijmo.angular2.nav';
import { WjInputModule } from '@grapecity/wijmo.angular2.input';

import { AppCommonsModule } from '../../../commons/app-commons.module';
import { PlessSharedModule } from '../../../shared/pless-shared.module';

import { KYMW0906Component } from './kymw0906.component';

/**
 * 予約商品設定画面 モジュール設定クラス
 *
 * @export KYMW0906Module
 * @class KYMW0906Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    AppCommonsModule,
    PlessSharedModule,
    WjNavModule,
    WjGridModule,
    WjInputModule,
  ],
  declarations: [
    KYMW0906Component,
  ],
  providers: [
  ],
})
export class KYMW0906Module { }
